/**
 * Theme Manager — NFC-e Tracker
 * Persistência e gerenciamento do tema Claro / Escuro (Dia / Noite)
 */

const THEME_STORAGE_KEY = 'nfce_theme';

export function getSavedTheme() {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === 'dark' || saved === 'light') {
      return saved;
    }
  } catch (e) {
    console.warn('Error reading theme from storage:', e);
  }
  return 'light';
}

export function setTheme(theme) {
  const finalTheme = theme === 'dark' ? 'dark' : 'light';
  try {
    localStorage.setItem(THEME_STORAGE_KEY, finalTheme);
  } catch (e) {
    console.warn('Error saving theme to storage:', e);
  }

  if (finalTheme === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }

  window.dispatchEvent(new CustomEvent('nfce-theme-changed', { detail: { theme: finalTheme } }));
  return finalTheme;
}

export function initTheme() {
  const theme = getSavedTheme();
  if (theme === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
  return theme;
}
